import { DEBUG_FLAG, LoggerFactory } from '@sync-video/logger';

declare const __SYNC_VIDEO_DEBUG__: boolean;

export const appLogger = LoggerFactory.forApp('app');

export function initAppLogging(): void {
  LoggerFactory.registerApp('app');

  if (__SYNC_VIDEO_DEBUG__) {
    try {
      localStorage.setItem(DEBUG_FLAG, 'true');
    } catch {
                            
    }
  }

  appLogger.create('Init').log('starting app');
}
